import React from "react";
import "../../css/TopPosterBanner.css";
import poster from "../../assets/harinaam-poster.jpg";
import posterMobile from "../../assets/harinaam-mobile.jpg"; // 👈 add this
import JSZip from "jszip";
import { saveAs } from "file-saver";

const TopPosterBanner = () => {
  const handleDownload = () => {
    const link = document.createElement("a");
    link.href = poster;
    link.download = "harinaam-poster.jpeg";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const downloadZip = async () => {
    const zip = new JSZip();

    // Fetch images as blob
    const img1 = await fetch(poster).then((res) => res.blob());
    const img2 = await fetch(posterMobile).then((res) => res.blob());

    zip.file("harinaam-desktop.jpg", img1);
    zip.file("harinaam-mobile.jpg", img2);

    const content = await zip.generateAsync({ type: "blob" });

    saveAs(content, "harinaam-posters.zip");
  };

  return (
    <div className="poster-banner-wrapper">
      <div className="poster-banner-container">
        {/* DOWNLOAD BUTTON */}
        <button className="download-btn" onClick={downloadZip}>
          ⬇ Download
        </button>

        {/* FULL WIDTH IMAGE */}
        <div className="poster-image full">
          <picture>
            {/* Mobile Image */}
            <source media="(max-width: 768px)" srcSet={posterMobile} />

            {/* Default Desktop Image */}
            <img src={poster} alt="Harinaam Sankirtan Poster" />
          </picture>
        </div>
      </div>
    </div>
  );
};

export default TopPosterBanner;
